module.exports = __webpack_public_path__ + "img/warning_hum.2eda8ee8.svg";